import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import {
  AnnouncementItemViewModel,
  AttendanceItemViewModel,
  ChannelArticleItemViewModel,
  PaymentItemViewModel,
  SlipItemViewModel,
  UnknownItemViewModel
} from 'src/app/models/item.model';
import { InViewportDirective } from '../../../external/angular-inviewport/src/app/in-viewport/in-viewport.directive';
import {
  SelectAttendanceAlertsEventPayload,
  SelectStudentEventPayload,
  ShowPaymentEventPayload,
  ShowSlipEventPayload
} from '../../models/event-payloads.model';
import { AnnouncementItemComponent } from '../announcement-item/announcement-item.component';
import { ArticleItemComponent } from '../article-item/article-item.component';
import { AttendanceItemComponent } from '../attendance-item/attendance-item.component';
import { ItemToolbarComponent } from '../item-toolbar/item-toolbar.component';
import { PaymentItemComponent } from '../payment-item/payment-item.component';
import { SlipItemComponent } from '../slip-item/slip-item.component';
import { UnknownItemComponent } from '../unknown-item/unknown-item.component';

@Component({
  selector: 'app-hub-item',
  templateUrl: './hub-item.component.html',
  styleUrls: ['./hub-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    InViewportDirective,
    ArticleItemComponent,
    ItemToolbarComponent,
    AnnouncementItemComponent,
    AttendanceItemComponent,
    PaymentItemComponent,
    SlipItemComponent,
    UnknownItemComponent
  ]
})
export class HubItemComponent implements OnInit {
  @Input() item:
    | ChannelArticleItemViewModel |
    AnnouncementItemViewModel |
    AttendanceItemViewModel |
    PaymentItemViewModel |
    SlipItemViewModel |
    UnknownItemViewModel;
  @Input() disablePublisherLink: boolean;
  @Output() selectChannel = new EventEmitter<number>();
  @Output() selectStudent = new EventEmitter<SelectStudentEventPayload>();
  @Output() selectItem = new EventEmitter<string>();
  @Output() selectAttendanceAlerts = new EventEmitter<SelectAttendanceAlertsEventPayload>();
  @Output() selectPaymentRequests = new EventEmitter<number>();
  @Output() toggleItemDone = new EventEmitter<number>();
  @Output() shareItem = new EventEmitter<number>();
  @Output() translateItem = new EventEmitter<number>();
  @Output() showOriginalItem = new EventEmitter<number>();
  @Output() openAttachment = new EventEmitter<string>();
  @Output() getThumb = new EventEmitter<string>();
  @Output() showPayment = new EventEmitter<ShowPaymentEventPayload>();
  @Output() showSlip = new EventEmitter<ShowSlipEventPayload>();
  @Output() inViewport = new EventEmitter<void>();
  @Output() reactWith = new EventEmitter<{ itemSequenceNumber: number; reactionId: string }>();

  inViewportChange$ = new Subject<boolean>();
  destroyed$: Subject<boolean>;

  constructor(private element: ElementRef) {}

  ngOnInit(): void {
    this.destroyed$ = new Subject<boolean>();
    this.inViewportChange$.pipe(debounceTime(300)).subscribe((value) => {
      if (value) this.inViewport.emit();
      console.log(`${this.item.title}: ${value}`);
    });
  }

  get itemAsChannelArticleItemViewModel(): ChannelArticleItemViewModel {
    return this.item as ChannelArticleItemViewModel;
  }
  get itemAsAnnouncementItemViewModel(): AnnouncementItemViewModel {
    return this.item as AnnouncementItemViewModel;
  }
  get itemAsAttendanceItemViewModel(): AttendanceItemViewModel {
    return this.item as AttendanceItemViewModel;
  }
  get itemAsPaymentItemViewModel(): PaymentItemViewModel {
    return this.item as PaymentItemViewModel;
  }
  get itemAsSlipItemViewModel(): SlipItemViewModel {
    return this.item as SlipItemViewModel;
  }
  get itemAsUnknownItemViewModel(): UnknownItemViewModel {
    return this.item as UnknownItemViewModel;
  }

  get inViewportOptions(): any {
    return {
      root: this.element.nativeElement.closest('ion-content'),
      threshold: 0.5
    };
  }

  onInViewportChange(event): void {
    this.inViewportChange$.next(event);
  }
}
